import {Icon, IconProps} from '@chakra-ui/react';

export function ArrowForwardIcon(props: IconProps) {
  return (
    <Icon width="5px" height="8px" viewBox="0 0 5 8" fill="none" color="#ABABAB" {...props}>
      <path d="M1 1L4 4L1 7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
  );
}
